import { render, staticRenderFns } from "./homePageSetting.vue?vue&type=template&id=327116b2&scoped=true"
import script from "./homePageSetting.vue?vue&type=script&lang=js"
export * from "./homePageSetting.vue?vue&type=script&lang=js"
import style0 from "./homePageSetting.vue?vue&type=style&index=0&id=327116b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327116b2",
  null
  
)

export default component.exports